export default {
  tag: "Operating Guide",
  title1: "How to Operate a Food Truck",
  title2: "in Orange County",
  subtitle: "A step-by-step guide to a mobile food facility permit in Orange County.",
  steps: [
    {
      title: "Register Your Business",
      desc: "File a DBA (Doing Business As) with the OC County Clerk and obtain your EIN from the IRS. This is the foundation of your legal business entity.",
    },
    {
      title: "Secure a Commissary Agreement",
      desc: "All mobile food units in Orange County must operate from a licensed commissary kitchen. You must have a signed commissary agreement before applying for your mobile food facility permit.",
    },
    {
      title: "Pass Construction Inspection",
      desc: "Your food truck must pass a preliminary construction inspection. All equipment must meet NSF standards and the vehicle must be built to county specifications.",
    },
    {
      title: "Apply for Required Permits",
      desc: "Submit your Mobile Food Facility (MFF) permit application to OC Environmental Health. Processing can take 4–8 weeks — we help you prepare a complete application to avoid delays.",
    },
    {
      title: "Obtain Business Licenses",
      desc: "Get a business license from each city in Orange County where you plan to operate. Many cities also require a separate vendor permit or mobile food vendor license.",
    },
    {
      title: "Schedule Evaluation Inspection",
      desc: "To completely understand Orange County regulations and kitchen requirements, schedule your MFF for Evaluation with our expert to determine your next step",
    },
  ],
  stats: [
    { value: "3,200+", label: "Registered Food Trucks in OC" },
    { value: "34", label: "Cities Across Orange County" },
    { value: "4–8 wks", label: "Average Permit Processing Time" },
    { value: "$800–$2,400", label: "Typical Annual Permit Costs" },
  ],
};